import Grid from "@material-ui/core/Grid"
import React from "react"
import TextField from "@material-ui/core/TextField"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import FieldSelect from "../../Table/FieldSelect"
import { useChildModalStyle } from "./style"
import { useCreate } from "./hooks"
import { Typography } from "@material-ui/core"

const Create = () => {
    const classes = useChildModalStyle()
    const {
        callback, cancelCallback,
        modalTimeStr, disabled, dialogData, isBusiness,
        text, handleChange, handleChangeArticleType,
        projectId, projectMoney, handleProjectIdChange, handleProjectMoneyChange,
    } = useCreate("single")
    const isThreeDay = dialogData.date.getTime() - new Date().getTime() < 2 * 24 * 3600 * 1000
    return (
        <BoardConfirmModal
            title="创建预约"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{modalTimeStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item>
                <FormControl className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        staticValueList={[]}
                        tableName="eat_article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>

            {
                // 创建时，只对商务部展示项目编号及项目金额
                isBusiness ? (
                    <>
                        <Grid container direction="column" justify="center">
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                                error={!!(projectId && projectId.length > 50)}
                                helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center">
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                                error={!!(projectMoney && projectMoney.length > 50)}
                                helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                    </>
                ) : null
            }
            {
                isBusiness && isThreeDay ? (
                    <>
                        <Grid container justify="flex-start" alignItems="center" className={classes.input}>
                                <Typography color="initial">
                                    注意：3天内的预约不可删除哦~
                                </Typography>
                        </Grid>
                    </>
                ) : null
            }
        </BoardConfirmModal>
    )
}

export default Create
